module.exports = __webpack_public_path__ + "img/FMR-active.817c2645.svg";